import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const AIIcon = (props) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon 
      {...other} 
      sx={sx}
      viewBox="0 0 46.0072 46.0072"
    >
      <defs>
        <linearGradient id="grad-orbit-ai" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2FD5EA"/>
          <stop offset="100%" stopColor="#5A49FF"/>
        </linearGradient>
      </defs>
      <circle cx="23.0036" cy="23.0036" r="23.0036" fill="url(#grad-orbit-ai)"/>
      <g fill="#FFFFFF">
        <path d="M25.75 30.621C27.8959 28.6539 37.7597 21.7729 37.9099 13.7832C38.0601 5.79342 27.5597 3.21124 22.9533 8.862C18.3468 3.21124 7.93227 5.79342 8.01811 13.776C8.10394 21.7586 18.0321 28.6468 20.1279 30.6138L21.0864 31.3291C21.643 31.7477 22.3227 31.9699 23.019 31.9608C23.7154 31.9518 24.3891 31.712 24.9346 31.279L25.75 30.621Z"/>
        <path d="M25.1995 42.3811C25.1995 42.3811 30.2065 37.7461 34.0977 36.4586C37.9888 35.1711 40.1848 32.4601 40.8285 29.9137C41.4723 27.3673 41.8228 27.1026 41.0717 26.8451C40.3207 26.5876 39.2549 30.1927 37.8744 31.473C36.4939 32.7534 33.5827 34.6418 31.3796 34.3914C29.1765 34.1411 30.371 32.7462 31.8016 32.2885C33.2322 31.8307 36.0933 30.1998 34.9775 28.8408C33.8616 27.4817 34.019 30.2714 29.6271 30.8937C25.2353 31.516 23.6116 35.1854 24.1338 37.603L25.1995 42.3811Z"/>
        <path d="M37.6885 31.1288C38.339 30.2116 38.9337 29.2562 39.4695 28.2676C39.7134 27.4767 39.9093 26.6717 40.0561 25.8571C40.0561 25.4923 38.8472 25.1418 38.2393 27.2233C37.8726 28.4927 37.6872 29.8075 37.6885 31.1288Z"/>
        <path d="M35.5352 32.5951C36.1364 32.2974 36.6946 31.9196 37.1946 31.4721C37.1946 31.4721 37.538 27.6883 37.5952 27.2234C37.6524 26.7584 36.8155 25.85 36.2504 27.7097C35.8461 29.3096 35.6064 30.9466 35.5352 32.5951Z"/>
        <path d="M20.8077 42.3811C20.8077 42.3811 15.8007 37.7461 11.9095 36.4586C8.01836 35.1711 5.82243 32.4601 5.17868 29.9137C4.53492 27.3673 4.18443 27.1026 4.93548 26.8451C5.68653 26.5876 6.74515 30.1927 8.12565 31.473C9.50615 32.7534 12.4174 34.6418 14.6204 34.3914C16.8235 34.1411 15.629 32.7462 14.1984 32.2885C12.7679 31.8307 9.90671 30.1998 11.0226 28.8408C12.1384 27.4817 11.981 30.2714 16.3729 30.8937C20.7647 31.516 22.3884 35.1854 21.8663 37.603L20.8077 42.3811Z"/>
        <path d="M8.31894 31.1288C7.66843 30.2116 7.07367 29.2562 6.53788 28.2676C6.29723 27.4836 6.10376 26.6858 5.9585 25.8786C5.9585 25.5138 7.16733 25.1633 7.77532 27.2448C8.13752 28.5076 8.32051 29.815 8.31894 31.1288Z"/>
        <path d="M10.4645 32.5951C9.87582 32.2946 9.32978 31.917 8.84085 31.4721C8.84085 31.4721 8.49751 27.6883 8.44029 27.2234C8.38306 26.7584 9.21995 25.85 9.78502 27.7097C10.1773 29.3108 10.405 30.9478 10.4645 32.5951Z"/>
      </g>
      <g fill="#FFFFFF">
        <rect x="21.4873" y="13.9336" width="3.0257" height="8.19"/>
        <rect x="18.912" y="16.5156" width="8.1901" height="3.0257"/>
      </g>
      <text 
        x="22.0036" 
        y="18" 
        fill="#0A1025" 
        fontSize="17" 
        fontWeight="900" 
        fontFamily="Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif" 
        textAnchor="middle" 
        dominantBaseline="middle" 
        letterSpacing="0.2" 
        stroke="#FFFFFF" 
        strokeWidth="0.4"
      >
        AI
      </text>
    </SvgIcon>
  );
};

export default AIIcon;
